import { loadPackage } from "common/utils/package-loader";
import "flickity/css/flickity.css";

export default class FlickityClass {
  #flickity;

  #flickitySelector;

  #flickityOptions;

  constructor(flickitySelector, flickityOptions) {
    this.#flickitySelector = flickitySelector;
    this.#flickityOptions = flickityOptions;
  }

  get flickity() {
    return this.#flickity;
  }

  get $flickity() {
    return document.querySelector(this.#flickitySelector);
  }

  async addOrModifyOptions(options) {
    this.#flickityOptions = { ...this.#flickityOptions, ...options };
    this.destroyFlickity();
    await this.initFlickity();
  }

  async initFlickity() {
    if (this.$flickity && !this.#flickity) {
      const FlickityConstructor = await loadPackage("flickity-as-nav-for");

      this.#flickity = new FlickityConstructor(this.#flickitySelector, this.#flickityOptions);
    }
  }

  destroyFlickity() {
    this.#flickity?.destroy();
    this.#flickity = undefined;
  }
}
